import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { compose } from 'redux';
import classNames from 'classnames';
import some from 'lodash/some'

import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { RadioButton } from 'primereact/radiobutton';

import JustificationModal from '@components/JustificationModal';
import LoadingAction from '@components/LoadingAction';

import {
  getListCoordinators,
  getListEvaluators,
  getListGestors,
  reassignEvaluatorFolios,
  updateEvaluator,
} from '@actions/evaluators';
import { sendActionToBitacora  } from '@actions/bitacora';

import { StatusConst } from '@constants/general';

class EvaluartorGeneral extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loadingPage: true,
      btnSubmitLoading: false,
      nombre: '',
      url: '',
      estatus: 1,
      replacementEvaluators: [],
      replacementEvaluator: null,
      replacementManagers: [],
      managerAssignments: {},
      currentManagers: [],
      replacementCoordinators: [],
      coordinatorAssignments: {},
      currentCoordinators: [],
      loadingCurrentAssignments: false,
      currentAssignmentsLoaded: false,
      currentAssignmentsError: '',
      loadingReplacementEvaluators: false,
      loadingReplacementAssignments: false,
      processingReassignment: false,
      replacementCatalogError: '',
      errors: [],
      showModalJustification: {
        isVisible: false,
        title: '',
        description: '',
        label: '',
        continueAction: null,
      },
    };
  }

  componentDidMount() {
    const { _nombre, _url, _estatus } = this.props
    this.setState({
      nombre: _nombre,
      url: _url,
      estatus: _estatus,
      loadingPage: false,
    })
  }

  componentDidUpdate(prevProps) {
    const { _id, _nombre, _url, _estatus } = this.props;
    if (String(prevProps._id) === String(_id)) return;

    this.setState({
      nombre: _nombre,
      url: _url,
      estatus: _estatus,
      replacementEvaluators: [],
      replacementEvaluator: null,
      replacementManagers: [],
      managerAssignments: {},
      currentManagers: [],
      replacementCoordinators: [],
      coordinatorAssignments: {},
      currentCoordinators: [],
      loadingCurrentAssignments: false,
      currentAssignmentsLoaded: false,
      currentAssignmentsError: '',
      loadingReplacementEvaluators: false,
      loadingReplacementAssignments: false,
      processingReassignment: false,
      replacementCatalogError: '',
      errors: [],
    });
  }

  onChange = ({ target }) => {
    const nextState = { [target.name]: target.value };
    if (target.name === 'estatus' && target.value === StatusConst.IS_ACTIVE) {
      nextState.replacementEvaluator = null;
      nextState.replacementManagers = [];
      nextState.managerAssignments = {};
      nextState.currentManagers = [];
      nextState.replacementCoordinators = [];
      nextState.coordinatorAssignments = {};
      nextState.currentCoordinators = [];
      nextState.loadingCurrentAssignments = false;
      nextState.currentAssignmentsLoaded = false;
      nextState.currentAssignmentsError = '';
      nextState.loadingReplacementEvaluators = false;
      nextState.loadingReplacementAssignments = false;
      nextState.replacementCatalogError = '';
    }
    this.setState(nextState, () => {
      this.validateFieldsOnchange(target.name, target.value);
      if (
        target.name === 'estatus' &&
        target.value === StatusConst.IS_SUSPENDED &&
        this.props._estatus === StatusConst.IS_ACTIVE
      ) {
        this.loadReplacementEvaluators();
        this.loadCurrentAssignments();
      }
    });
  };

  getUserId = (user) => user?.id_usuario ?? user?.fi_id_usuario ?? user?.id;

  getAssignmentKey = (user) => {
    const userId = this.getUserId(user);
    return userId == null ? user?.correo : String(userId);
  };

  getCatalogResult = (response) => {
    if (!response?.status) return { data: response?.data || [], hasError: false };
    if (response.status === 404) return { data: [], hasError: false };
    return { data: [], hasError: true };
  };

  loadCurrentAssignments = async () => {
    const { _id, getListGestors, getListCoordinators, t } = this.props;
    const evaluatorId = _id;
    this.setState({
      currentManagers: [],
      currentCoordinators: [],
      managerAssignments: {},
      coordinatorAssignments: {},
      loadingCurrentAssignments: true,
      currentAssignmentsLoaded: false,
      currentAssignmentsError: '',
    });

    const [managersResponse, coordinatorsResponse] = await Promise.all([
      getListGestors(evaluatorId, 'active'),
      getListCoordinators(evaluatorId, 'active'),
    ]);
    const isStillStartingSuspension =
      String(this.props._id) === String(evaluatorId) &&
      this.props._estatus === StatusConst.IS_ACTIVE &&
      this.state.estatus === StatusConst.IS_SUSPENDED;
    if (!isStillStartingSuspension) return;

    const managersResult = this.getCatalogResult(managersResponse);
    const coordinatorsResult = this.getCatalogResult(coordinatorsResponse);
    const hasError = managersResult.hasError || coordinatorsResult.hasError;
    this.setState({
      currentManagers: managersResult.data,
      currentCoordinators: coordinatorsResult.data,
      loadingCurrentAssignments: false,
      currentAssignmentsLoaded: !hasError,
      currentAssignmentsError: hasError ? t('No fue posible cargar los gestores o coordinadores actuales') : '',
    });
  };

  loadReplacementEvaluators = async () => {
    const { getListEvaluators, _id, t } = this.props;
    const evaluatorId = _id;
    this.setState({
      loadingReplacementEvaluators: true,
      replacementCatalogError: '',
    });
    const response = await getListEvaluators('active', 'external');
    const isStillStartingSuspension =
      String(this.props._id) === String(evaluatorId) &&
      this.props._estatus === StatusConst.IS_ACTIVE &&
      this.state.estatus === StatusConst.IS_SUSPENDED;
    if (!isStillStartingSuspension) return;

    const replacementEvaluators = response?.status
      ? []
      : (response?.data || []).filter(evaluator => String(evaluator.id) !== String(evaluatorId));
    this.setState({
      replacementEvaluators,
      loadingReplacementEvaluators: false,
      replacementCatalogError: response?.status ? t('No fue posible cargar las casas evaluadoras disponibles') : '',
    });
  };

  onChangeReplacementEvaluator = async ({ value }) => {
    const { getListGestors, getListCoordinators, t } = this.props;
    const selectedEvaluatorId = value?.id;
    this.setState({
      replacementEvaluator: value,
      replacementManagers: [],
      managerAssignments: {},
      replacementCoordinators: [],
      coordinatorAssignments: {},
      loadingReplacementAssignments: Boolean(value),
      replacementCatalogError: '',
    }, () => this.validateFieldsOnchange('replacementEvaluator', value));

    if (!value) return;

    const [managersResponse, coordinatorsResponse] = await Promise.all([
      getListGestors(value.id, 'active'),
      getListCoordinators(value.id, 'active'),
    ]);
    if (String(this.state.replacementEvaluator?.id) !== String(selectedEvaluatorId)) return;
    const managersResult = this.getCatalogResult(managersResponse);
    const coordinatorsResult = this.getCatalogResult(coordinatorsResponse);
    const hasError = managersResult.hasError || coordinatorsResult.hasError;
    this.setState({
      replacementManagers: managersResult.data,
      replacementCoordinators: coordinatorsResult.data,
      loadingReplacementAssignments: false,
      replacementCatalogError: hasError ? t('No fue posible cargar los gestores o coordinadores de la casa seleccionada') : '',
    });
  };

  onChangeManagerAssignment = (currentManagerId, replacementManager) => {
    this.setState(prevState => ({
      managerAssignments: {
        ...prevState.managerAssignments,
        [currentManagerId]: replacementManager,
      },
    }), () => this.validateFieldsOnchange('managerAssignments', replacementManager));
  };

  onChangeCoordinatorAssignment = (currentCoordinatorId, replacementCoordinator) => {
    this.setState(prevState => ({
      coordinatorAssignments: {
        ...prevState.coordinatorAssignments,
        [currentCoordinatorId]: replacementCoordinator,
      },
    }), () => this.validateFieldsOnchange('coordinatorAssignments', replacementCoordinator));
  };

  buildFolioReassignmentPayload = () => {
    const {
      replacementEvaluator,
      managerAssignments,
      coordinatorAssignments,
      currentManagers,
      currentCoordinators,
    } = this.state;

    return {
      idEvaluadorNuevo: replacementEvaluator?.id,
      nombre: this.state.nombre,
      url: this.state.url,
      usuarios: [
        ...currentCoordinators.map(usuarioAnterior => ({
          idUsuarioAnterior: this.getUserId(usuarioAnterior),
          idUsuarioNuevo: this.getUserId(
            coordinatorAssignments[this.getAssignmentKey(usuarioAnterior)]
          ),
          idRol: 8,
        })),
        ...currentManagers.map(usuarioAnterior => ({
          idUsuarioAnterior: this.getUserId(usuarioAnterior),
          idUsuarioNuevo: this.getUserId(
            managerAssignments[this.getAssignmentKey(usuarioAnterior)]
          ),
          idRol: 2,
        })),
      ],
    };
  };

  validateFieldsOnchange = (name, value) => {
    const { errors } = this.state;
    if (errors[name] && value) {
      delete errors[name];
      this.setState({ errors });
    }
  };

  validateFields = async () => {
    const { t, _estatus } = this.props;
    const {
      nombre, url, estatus, replacementEvaluator, managerAssignments, coordinatorAssignments,
      currentManagers, currentCoordinators, currentAssignmentsLoaded, currentAssignmentsError
    } = this.state;
    let errors = {};
    if (!nombre) errors = { ...errors, 'nombre': `${t('Nombre')} ${t('es requerido')}`  }
    if (!url) errors = { ...errors, 'url': `${t('URL')} ${t('es requerido')}`  }
    const isStartingSuspension = _estatus === StatusConst.IS_ACTIVE && estatus === StatusConst.IS_SUSPENDED;
    if (isStartingSuspension) {
      if (!currentAssignmentsLoaded || currentAssignmentsError) {
        errors = { ...errors, currentAssignments: t('No fue posible validar los usuarios actuales') }
      }
      const hasCurrentAssignments = currentManagers.length > 0 || currentCoordinators.length > 0;
      if (hasCurrentAssignments && !replacementEvaluator) {
        errors = { ...errors, replacementEvaluator: `${t('Nueva casa evaluadora')} ${t('es requerido')}` }
      }
      const usersWithoutId = [
        ...currentManagers,
        ...currentCoordinators,
        ...Object.values(managerAssignments),
        ...Object.values(coordinatorAssignments),
      ].some(user => !this.getUserId(user));
      if (usersWithoutId) {
        errors = { ...errors, userIds: t('No fue posible obtener el identificador de uno o más usuarios') }
      }
      const allManagersAssigned = currentManagers.every(
        manager => managerAssignments[this.getAssignmentKey(manager)]
      )
      if (!allManagersAssigned) errors = { ...errors, managerAssignments: t('Asigna un reemplazo a todos los gestores') }
      const allCoordinatorsAssigned = currentCoordinators.every(
        coordinator => coordinatorAssignments[this.getAssignmentKey(coordinator)]
      )
      if (!allCoordinatorsAssigned) {
        errors = { ...errors, coordinatorAssignments: t('Asigna un reemplazo a todos los coordinadores') }
      }
    }
    this.setState({ errors });
    return errors;
  };

  onSubmit = async (e) => {
    e.preventDefault();
    this.setState({btnSubmitLoading: true})
    const { t } = this.props
    const validate = await this.validateFields()
    if (some(validate, {})) return this.setState({btnSubmitLoading: false})

    const isStartingSuspension = this.props._estatus === StatusConst.IS_ACTIVE &&
      this.state.estatus === StatusConst.IS_SUSPENDED;
    const hasCurrentAssignments = this.state.currentManagers.length > 0 ||
      this.state.currentCoordinators.length > 0;

    return this.setState({
      showModalJustification: {
        isVisible: true,
        title: t('CONFIRMACIÓN'),
        description: t('¿Esta seguro que desea hacer este cambio?'),
        label: t('Justificación del cambio'),
        continueAction: ({justification}) => isStartingSuspension && hasCurrentAssignments
          ? this.onReassignAndSuspend(justification)
          : this.onUpdateEvaluator(justification),
      },
    });

  };

  onReassignAndSuspend = async (justification) => {
    const {
      _id,
      reassignEvaluatorFolios,
      loadListEvaluators,
      sendActionToBitacora,
    } = this.props;
    const { nombre, url, replacementEvaluator } = this.state;

    this.setState({ processingReassignment: true });

    const reassignmentResponse = await reassignEvaluatorFolios(
      _id,
      this.buildFolioReassignmentPayload()
    );
    if (reassignmentResponse?.status) {
      return this.setState({ processingReassignment: false, btnSubmitLoading: false });
    }

    await sendActionToBitacora({
      transactionName: 'actEvaluador',
      reason: `${nombre} || reasignación a ${replacementEvaluator.nombre} || ${justification}`,
    });
    await loadListEvaluators();

    return this.setState({ processingReassignment: false, btnSubmitLoading: false });
  };
  
  onUpdateEvaluator = async (justification) => {
    const { updateEvaluator, loadListEvaluators, sendActionToBitacora } = this.props
    const { nombre, url, estatus } = this.state
    const response = await updateEvaluator({nombre, url, estatus})
    if (!response?.status) {
      const dataBitacora = {
        transactionName: 'actEvaluador',
        reason: `${nombre} || ${justification}`,
      }
      await sendActionToBitacora(dataBitacora)
            
      loadListEvaluators()
    }
    return this.setState({ btnSubmitLoading: false });

  }

  render() {
    const { t, _tipo, _estatus } = this.props;
    const {
      loadingPage, nombre, url, estatus, replacementEvaluators, replacementEvaluator,
      replacementManagers, managerAssignments, currentManagers,
      replacementCoordinators, coordinatorAssignments, currentCoordinators,
      loadingReplacementEvaluators, loadingReplacementAssignments, replacementCatalogError,
      loadingCurrentAssignments, currentAssignmentsLoaded, currentAssignmentsError,
      processingReassignment, btnSubmitLoading, errors, showModalJustification
    } = this.state;
    const isStartingSuspension = _estatus === StatusConst.IS_ACTIVE && estatus === StatusConst.IS_SUSPENDED;
    const hasCurrentAssignments = currentManagers.length > 0 || currentCoordinators.length > 0;
    const allManagersAssigned = currentManagers.every(
      manager => managerAssignments[this.getAssignmentKey(manager)]
    );
    const allCoordinatorsAssigned = currentCoordinators.every(
      coordinator => coordinatorAssignments[this.getAssignmentKey(coordinator)]
    );
    const usersWithoutId = [
      ...currentManagers,
      ...currentCoordinators,
      ...Object.values(managerAssignments),
      ...Object.values(coordinatorAssignments),
    ].some(user => !this.getUserId(user));
    const isLoadingSuspensionData = loadingCurrentAssignments ||
      loadingReplacementEvaluators || loadingReplacementAssignments || processingReassignment;
    const isSuspensionReady = !isStartingSuspension || Boolean(
      currentAssignmentsLoaded && !currentAssignmentsError &&
      (!hasCurrentAssignments || replacementEvaluator) &&
      allManagersAssigned && allCoordinatorsAssigned && !usersWithoutId &&
      !loadingCurrentAssignments && !loadingReplacementEvaluators && !loadingReplacementAssignments
    );

    const isFormFieldValid = (name) => !!errors[name];
    const getFormErrorMessage = (name) =>
      isFormFieldValid(name) && (
        <small className="p-error">{errors[name]}</small>
      );

    if (loadingPage) return true;
    return (
      <>
      {isLoadingSuspensionData && <LoadingAction />}
      <form onSubmit={this.onSubmit} autoComplete="false" className="p-col-12">
        <div className="p-fluid p-grid p-mb-4">
          <div className="p-col-2 p-field p-text-right">
            <label htmlFor="title" className="p-text-bold p-pb-2">
              {t('Nombre')}
            </label>
          </div>
          <div className="p-col-10 p-field">
            <InputText
              name="nombre"
              type="text"
              value={nombre}
              onChange={this.onChange}
              className={classNames({
                'p-invalid': isFormFieldValid(`nombre`),
              })}
            />
            {getFormErrorMessage(`nombre`)}
          </div>
          <div className="p-col-2 p-field p-text-right">
            <label className="p-text-bold p-pb-2 p-mr-3">
              {t('URL')}
            </label>
          </div>
          <div className="p-col-10 p-field ">
            <InputText
              name="url"
              type="text"
              value={url}
              onChange={this.onChange}
              className={classNames({
                'p-invalid': isFormFieldValid(`url`),
              })}
            />
            {getFormErrorMessage(`url`)}
          </div>
          {/* <div className="p-col-2 p-field p-text-right">
            <label className="p-text-bold p-pb-2 p-mr-3">
              {t('Tipo')}
            </label>
          </div>
          <div className="p-col-10 p-field ">
            <label>{_tipo}</label>
          </div> */}
          <div className="p-col-2 p-field p-text-right">
            <label className="p-text-bold p-pb-2 p-mr-3">
              {t('Estatus')}
            </label>
          </div>
          <div className="p-col-8f ield-radiobutton">
            <div className='p-mt-4'>
                <RadioButton
                  inputId="estatus"
                  name="estatus"
                  value={StatusConst.IS_ACTIVE}
                  onChange={this.onChange}
                  checked={estatus === StatusConst.IS_ACTIVE}
                />
              <label className="p-pl-2">{t('Activo')}</label>
            </div>
            <div className='p-mt-4'>
                <RadioButton
                  inputId="estatus"
                  name="estatus"
                  value={StatusConst.IS_SUSPENDED}
                  onChange={this.onChange}
                  checked={estatus === StatusConst.IS_SUSPENDED}
                />
              <label className="p-pl-2">{t('Suspendido')}</label>
            </div>
          </div>
          {isStartingSuspension && hasCurrentAssignments && (
            <div className="p-col-12 p-mt-4">
              <div className="p-grid p-p-3" style={{ backgroundColor: '#f4f7fb', border: '1px solid #d9e2ec', borderRadius: '4px' }}>
                <div className="p-col-12">
                  <h3 className="p-m-0">{t('Reasignación de casa evaluadora')}</h3>
                  <p className="p-mt-2 p-mb-0">
                    {t('Selecciona la nueva casa evaluadora y el reemplazo de cada coordinador y gestor.')}
                  </p>
                  {replacementCatalogError && <small className="p-error">{replacementCatalogError}</small>}
                  {currentAssignmentsError && <small className="p-error p-d-block">{currentAssignmentsError}</small>}
                </div>
                <div className="p-col-12">
                  <div className="p-grid p-text-bold p-p-2" style={{ borderBottom: '1px solid #d9e2ec' }}>
                    <div className="p-col-12 p-md-6">{t('Actual')}</div>
                    <div className="p-col-12 p-md-6">{t('Nuevo')}</div>
                  </div>
                  <div className="p-grid p-ai-center p-p-2" style={{ borderBottom: '1px solid #e8edf2' }}>
                    <div className="p-col-12 p-md-6">
                      <div className="p-text-bold">{t('Casa evaluadora')}</div>
                      <div>{nombre}</div>
                    </div>
                    <div className="p-col-12 p-md-6">
                      <Dropdown
                        name="replacementEvaluator"
                        value={replacementEvaluator}
                        options={replacementEvaluators}
                        optionLabel="nombre"
                        placeholder={loadingReplacementEvaluators ? t('Cargando casas evaluadoras...') : t('Selecciona una casa evaluadora')}
                        onChange={this.onChangeReplacementEvaluator}
                        disabled={loadingReplacementEvaluators || loadingCurrentAssignments}
                        className={classNames({ 'p-invalid': isFormFieldValid('replacementEvaluator') })}
                        style={{ width: '100%' }}
                      />
                      {getFormErrorMessage('replacementEvaluator')}
                    </div>
                  </div>
                  <div className="p-p-2 p-mt-2 p-text-bold">{t('Coordinador')}</div>
                  {!loadingCurrentAssignments && currentAssignmentsLoaded && currentCoordinators.length === 0 && (
                    <div className="p-p-2">{t('La casa evaluadora no tiene coordinadores externos activos.')}</div>
                  )}
                  {currentCoordinators.map(coordinator => {
                    const assignmentKey = this.getAssignmentKey(coordinator);
                    return (
                      <div className="p-grid p-ai-center p-p-2" key={assignmentKey} style={{ borderBottom: '1px solid #e8edf2' }}>
                        <div className="p-col-12 p-md-6">
                          <div>{coordinator.nombre}</div>
                          <small className="p-text-secondary">{coordinator.correo}</small>
                        </div>
                        <div className="p-col-12 p-md-6">
                          <Dropdown
                            value={coordinatorAssignments[assignmentKey] || null}
                            options={replacementCoordinators}
                            optionLabel="nombre"
                            placeholder={loadingReplacementAssignments ? t('Cargando coordinadores...') : t('Selecciona el nuevo coordinador')}
                            onChange={({ value }) => this.onChangeCoordinatorAssignment(assignmentKey, value)}
                            disabled={!replacementEvaluator || loadingReplacementAssignments}
                            style={{ width: '100%' }}
                          />
                        </div>
                      </div>
                    );
                  })}
                  {replacementEvaluator && !loadingReplacementAssignments && replacementCoordinators.length === 0 && (
                    <small className="p-error">{t('La casa seleccionada no tiene coordinadores externos activos')}</small>
                  )}
                  {getFormErrorMessage('coordinatorAssignments')}

                  <div className="p-p-2 p-mt-3 p-text-bold">{t('Gestor')}</div>
                  {!loadingCurrentAssignments && currentAssignmentsLoaded && currentManagers.length === 0 && (
                    <div className="p-p-2">{t('La casa evaluadora no tiene gestores activos.')}</div>
                  )}
                  {currentManagers.map(manager => {
                    const assignmentKey = this.getAssignmentKey(manager);
                    return (
                      <div className="p-grid p-ai-center p-p-2" key={assignmentKey} style={{ borderBottom: '1px solid #e8edf2' }}>
                        <div className="p-col-12 p-md-6">
                          <div>{manager.nombre}</div>
                          <small className="p-text-secondary">{manager.correo}</small>
                        </div>
                        <div className="p-col-12 p-md-6">
                          <Dropdown
                            value={managerAssignments[assignmentKey] || null}
                            options={replacementManagers}
                            optionLabel="nombre"
                            placeholder={loadingReplacementAssignments ? t('Cargando gestores...') : t('Selecciona el nuevo gestor')}
                            onChange={({ value }) => this.onChangeManagerAssignment(assignmentKey, value)}
                            disabled={!replacementEvaluator || loadingReplacementAssignments}
                            style={{ width: '100%' }}
                          />
                        </div>
                      </div>
                    );
                  })}
                  {replacementEvaluator && !loadingReplacementAssignments && replacementManagers.length === 0 && (
                    <small className="p-error">{t('La casa seleccionada no tiene gestores activos')}</small>
                  )}
                  {getFormErrorMessage('managerAssignments')}
                  {getFormErrorMessage('currentAssignments')}
                  {getFormErrorMessage('userIds')}
                </div>
              </div>
            </div>
          )}
          {isStartingSuspension && currentAssignmentsLoaded && !hasCurrentAssignments && (
            <div className="p-col-12 p-mt-4">
              <small className="p-text-secondary">
                {t('La casa evaluadora no tiene gestores ni coordinadores activos; se suspenderá sin reasignación.')}
              </small>
            </div>
          )}
        </div>
        <div className="p-col-12 footer-btn">
          <div className="p-d-flex p-jc-end">
            <Button
              label={t('Guardar cambios')}
              type="submit"
              className="p-button-primary"
              loading={btnSubmitLoading}
              disabled={!isSuspensionReady || btnSubmitLoading || processingReassignment}
            />
          </div>
        </div>
      </form>
      <JustificationModal
          display={showModalJustification.isVisible}
          title={showModalJustification.title}
          description={showModalJustification.description}
          label={showModalJustification.label}
          onHidden={() => this.setState({showModalJustification: { isVisible: false }, btnSubmitLoading: false})}
          onContinueAction={showModalJustification.continueAction}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  _id: state.evaluator.id,
  _nombre: state.evaluator.nombre,
  _url: state.evaluator.url,
  _estatus: state.evaluator.estatus,
  _tipo: state.evaluator.tipo,
});

const mapDispatchToProps = {
  getListCoordinators,
  getListEvaluators,
  getListGestors,
  reassignEvaluatorFolios,
  updateEvaluator, 
  sendActionToBitacora
};

export default compose(
  withTranslation(),
  connect(mapStateToProps, mapDispatchToProps)
)(EvaluartorGeneral);
